import { usePermissions } from '../../authentication';
import { useConfigMatch } from '../index';

export const useUserPermissionOrFeatureFlagEnabled = (permission, featureFlag) => {
    const userPermission = usePermissions(permission);
    const accountPermission = useConfigMatch({ [featureFlag]: 'true' });
    return userPermission || accountPermission;
};
